import _ from 'lodash';
Highcharts.setOptions({
    global: {
      useUTC: false
    }
});

function ChartGeneratorService($http) {
    'ngInject';

    const service = {};

    //라인차트 그래프 옵션
    service.setLineChartOptions = function (params) {
        /**
         * generate c3 data options
         */
        let keyName = params.keyName;
        let chartData = {
            columns: [params.columnData],
            types: params.type
        };

        let color = {
            pattern: [params.color]
        };

        let size = {
            height: params.height
        };

        let legend = {
            show: params.legendShow
        };

        let grid = {
            y: {
                show: true,
                lines: [
                    { value: 0, text: '', position: 'start', class: 'grey' },
                    { value: 50, text: '', position: 'start', class: 'grey' },
                    { value: 100, text: '', position: 'start', class: 'grey' },
                ],
                inner: true
            }
        };

        let axis = {
            y: {
                max: 100,
                min: 0,
                tick: {
                    values: [0, 50, 100]
                }
            },
            x: {
                hide: true
            }
        };

        let point = {
            show: params.pointShow
        };

        let tooltip = {
            show: params.tooltipShow
        };

        let options = {
            targetId: params.targetId,
            padding: params.padding,
            data: chartData,
            color: color,
            size: size,
            legend: legend,
            grid: grid,
            axis: axis,
            point: point,
            tooltip: tooltip
        };

        return options;
    };

    //C3 line chart
    service.generateLineChart = function (params) {
        Highcharts.chart(params.targetId.substr(1), {
            chart: {
                type: 'spline',
                height: (params.size.height - 10),
                backgroundColor: 'transparent'
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            xAxis: {
                tickLength: 0,
                labels: {
                    enabled: false
                }
            },
            yAxis: {
                title: {
                    enabled: false
                },
                min: params.axis.y.min,
                max: params.axis.y.max,
                startOnTick: false,
                endOnTick: false,
                tickPositions: params.axis.y.tick.values,
                gridLineColor: '#3e3e3e'
            },
            colors: params.color.pattern,
            plotOptions: {
                series: {
                    marker: {
                        enabled: false
                    }
                }
            },
            series: [{
                data: params.data.columns[0].slice(1)
            }]
        });

        // let lineChart = c3.generate({
        //     bindto: params.targetId,
        //     padding: params.padding,
        //     data: params.data,
        //     color: params.color,
        //     size: params.size,
        //     legend: params.legend,
        //     grid: params.grid,
        //     axis: params.axis,
        //     point: params.point,
        //     tooltip: params.tooltip
        // });
    };

    //set options for donut chart
    service.setDonutChartOptions = function (params) {
        let keyName = params.keyName + '_empty';
        let options = {
            targetId: params.targetId,
            data: {
                columns: [
                    [keyName, params.maxValue - params.value],
                    [params.keyName, params.value]
                ],
                type: 'donut'
            },
            color: {
                pattern: params.color
            },
            size: params.size,
            donut: params.donut,
            tooltip: { show: false },
            legend: { show: false }
        };

        return options;
    }

    //generate c3 donut chart
    service.generateDonutChart = function (params) {
        let donutChart = c3.generate({
            bindto: params.targetId,
            data: params.data,
            color: params.color,
            size: params.size,
            donut: params.donut,
            tooltip: params.tooltip,
            legend: params.legend

            //   bindto: '#player-distance-donut-chart',
            //   data: {
            //       columns: [
            //           ['data1', 20-playerDistance],
            //           ['data2', playerDistance]
            //       ],
            //       type: 'donut'
            //   },
            //   color:
            //   size:{
            //       height:100,
            //       width:100
            //   },
            //   donut: {
            //       label: {show:false}
            //   },
            //   tooltip:{show: false},
            //   legend: {show: false}
        });
    };

    //generate velocity chart
    service.createVelocityGaugeChart = function (params) {
        let velocity = d3.select(params.targetId)
            .append("svg")
            .attr("width", "100px").attr("height", "100px");
        let g = velocity.append("g").attr("transform", "translate(50,50)");
        let gg = viz.gg()
            .domain(params.domain)
            .outerRadius(45)
            .innerRadius(10)
            .value((params.domain[1] + params.domain[0]))
            .duration(500);

        gg.defs(velocity);
        g.call(gg);
        return gg;
    }

    service.updateVelocityGaugeChart = function (velocity, gauges, domain) {
        gauges.setNeedle(domain[0] + velocity * (domain[1] - domain[0]));
    }

    //liquid fill gauge options
    service.getLiquidGaugeOptions = function () {
        //liquid gauge chart
        let options = {
            targetId: '#',
            svgId: 'template',
            minValue: 0, // The gauge minimum value.
            maxValue: 100, // The gauge maximum value.
            circleThickness: 0.2, // The outer circle thickness as a percentage of it's radius.
            circleFillGap: 0.05, // The size of the gap between the outer circle and wave circle as a percentage of the outer circles radius.
            circleColor: "#c833c8", // The color of the outer circle.
            waveHeight: 0.1, // The wave height as a percentage of the radius of the wave circle.
            waveCount: 2, // The number of full waves per width of the wave circle.
            waveRiseTime: 1000, // The amount of time in milliseconds for the wave to rise from 0 to it's final height.
            waveAnimateTime: 1000, // The amount of time in milliseconds for a full wave to enter the wave circle.
            waveRise: true, // Control if the wave should rise from 0 to it's full height, or start at it's full height.
            waveHeightScaling: true, // Controls wave size scaling at low and high fill percentages. When true, wave height reaches it's maximum at 50% fill, and minimum at 0% and 100% fill. This helps to prevent the wave from making the wave circle from appear totally full or empty when near minimum or maximum fill.
            waveAnimate: true, // Controls if the wave scrolls or is static.
            waveColor: "#ff5eff", // The color of the fill wave.
            waveOffset: 0, // The amount to initially offset the wave. 0 = no offset. 1 = offset of one full wave.
            textVertPosition: 0.5, // The height at which to display the percentage text withing the wave circle. 0 = bottom, 1 = top.
            textSize: 1, // The relative height of the text to display in the wave circle. 1 = 50%
            valueCountUp: true, // If true, the displayed value counts up from 0 to it's final value upon loading. If false, the final value is displayed.
            displayPercent: true, // If true, a % symbol is displayed after the value.
            textColor: "#c833c8", // The color of the value text when the wave does not overlap it.
            waveTextColor: "#A4DBf8" // The color of the value text when the wave overlaps it.
        };

        return options;
    }

    //liquid fill gauge chart
    service.loadLiquidFillGauge = function (value, params) {
        let liquidFillGauge = d3.select(params.targetId)
            .append("svg").attr("width", params.size.width).attr("height", params.size.height)
            .attr("style", "margin-top:5px;");

        let radius = Math.min(parseInt(liquidFillGauge.style("width")), parseInt(liquidFillGauge.style("height"))) / 2;
        let locationX = parseInt(liquidFillGauge.style("width")) / 2 - radius;
        let locationY = parseInt(liquidFillGauge.style("height")) / 2 - radius;
        let fillPercent = Math.max(params.minValue, Math.min(params.maxValue, value)) / params.maxValue;

        let waveHeightScale;
        if (params.waveHeightScaling) {
            waveHeightScale = d3.scale.linear()
                .range([0, params.waveHeight, 0])
                .domain([0, 50, 100]);
        } else {
            waveHeightScale = d3.scale.linear()
                .range([params.waveHeight, params.waveHeight])
                .domain([0, 100]);
        }

        let textPixels = (params.textSize * radius / 2);
        let textFinalValue = parseFloat(value).toFixed(2);
        let textStartValue = params.valueCountUp ? params.minValue : textFinalValue;
        let percentText = params.displayPercent ? "%" : "";
        let circleThickness = params.circleThickness * radius;
        let circleFillGap = params.circleFillGap * radius;
        let fillCircleMargin = circleThickness + circleFillGap;
        let fillCircleRadius = radius - fillCircleMargin;
        let waveHeight = fillCircleRadius * waveHeightScale(fillPercent * 100);

        let waveLength = fillCircleRadius * 2 / params.waveCount;
        let waveClipCount = 1 + params.waveCount;
        let waveClipWidth = waveLength * waveClipCount;

        // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
        let textRounder = function (value) { return Math.round(value); };
        if (parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))) {
            textRounder = function (value) { return parseFloat(value).toFixed(1); };
        }

        if (parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))) {
            textRounder = function (value) { return parseFloat(value).toFixed(2); };
        }

        // Data for building the clip wave area.
        let data = [];
        for (let i = 0; i <= 40 * waveClipCount; i++) {
            data.push({ x: i / (40 * waveClipCount), y: (i / (40)) });
        }

        // Scales for drawing the outer circle.
        let gaugeCircleX = d3.scale.linear().range([0, 2 * Math.PI]).domain([0, 1]);
        let gaugeCircleY = d3.scale.linear().range([0, radius]).domain([0, radius]);

        // Scales for controlling the size of the clipping path.
        let waveScaleX = d3.scale.linear().range([0, waveClipWidth]).domain([0, 1]);
        let waveScaleY = d3.scale.linear().range([0, waveHeight]).domain([0, 1]);

        // Scales for controlling the position of the clipping path.
        // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
        // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
        // circle at 100%.
        let waveRiseScale = d3.scale.linear()
            .range([(fillCircleMargin + fillCircleRadius * 2 + waveHeight), (fillCircleMargin - waveHeight)])
            .domain([0, 1]);

        let waveAnimateScale = d3.scale.linear()
            .range([0, waveClipWidth - fillCircleRadius * 2]) // Push the clip area one full wave then snap back.
            .domain([0, 1]);

        // Scale for controlling the position of the text within the gauge.
        let textRiseScaleY = d3.scale.linear()
            .range([fillCircleMargin + fillCircleRadius * 2, (fillCircleMargin + textPixels * 0.7)])
            .domain([0, 1]);

        // Center the gauge within the parent SVG.
        let gaugeGroup = liquidFillGauge.append("g")
            .attr('transform', 'translate(' + locationX + ',' + locationY + ')');

        // Draw the outer circle.
        let gaugeCircleArc = d3.svg.arc()
            .startAngle(gaugeCircleX(0))
            .endAngle(gaugeCircleX(1))
            .outerRadius(gaugeCircleY(radius))
            .innerRadius(gaugeCircleY(radius - circleThickness));

        gaugeGroup.append("path")
            .attr("d", gaugeCircleArc)
            .style("fill", params.circleColor)
            .attr('transform', 'translate(' + radius + ',' + radius + ')');

        // Text where the wave does not overlap.
        let text1 = gaugeGroup.append("text")
            .text(textRounder(textStartValue) + percentText)
            .attr("class", "liquidFillGaugeText")
            .attr("text-anchor", "middle")
            .attr("font-size", textPixels + "px")
            .style("fill", params.textColor)
            .attr('transform', 'translate(' + radius + ',' + textRiseScaleY(params.textVertPosition) + ')');

        // The clipping wave area.
        let clipArea = d3.svg.area()
            .x(function (d) { return waveScaleX(d.x); })
            .y0(function (d) { return waveScaleY(Math.sin(Math.PI * 2 * params.waveOffset * -1 + Math.PI * 2 * (1 - params.waveCount) + d.y * 2 * Math.PI)); })
            .y1(function (d) { return (fillCircleRadius * 2 + waveHeight); });
        let waveGroup = gaugeGroup.append("defs")
            .append("clipPath")
            .attr("id", "clipWave" + params.targetId);
        let wave = waveGroup.append("path")
            .datum(data)
            .attr("d", clipArea)
            .attr("T", 0);

        // The inner circle with the clipping wave attached.
        let fillCircleGroup = gaugeGroup.append("g")
            .attr("clip-path", "url(#clipWave" + params.targetId + ")");
        fillCircleGroup.append("circle")
            .attr("cx", radius)
            .attr("cy", radius)
            .attr("r", fillCircleRadius)
            .style("fill", params.waveColor);

        // Text where the wave does overlap.
        let text2 = fillCircleGroup.append("text")
            .text(textRounder(textStartValue) + percentText)
            .attr("class", "liquidFillGaugeText")
            .attr("text-anchor", "middle")
            .attr("font-size", textPixels + "px")
            .style("fill", params.waveTextColor)
            .attr('transform', 'translate(' + radius + ',' + textRiseScaleY(params.textVertPosition) + ')');

        // Make the value count up.
        if (params.valueCountUp) {
            let textTween = function () {
                let i = d3.interpolate(this.textContent, textFinalValue);
                return function (t) { this.textContent = textRounder(i(t)) + percentText; }
            };
            text1.transition()
                .duration(params.waveRiseTime)
                .tween("text", textTween);
            text2.transition()
                .duration(params.waveRiseTime)
                .tween("text", textTween);
        }

        // Make the wave rise. wave and waveGroup are separate so that horizontal and vertical movement can be controlled independently.
        let waveGroupXPosition = fillCircleMargin + fillCircleRadius * 2 - waveClipWidth;
        if (params.waveRise) {
            waveGroup.attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(0) + ')')
                .transition()
                .duration(params.waveRiseTime)
                .attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(fillPercent) + ')')
                .each("start", function () { wave.attr('transform', 'translate(1,0)'); }); // This transform is necessary to get the clip wave positioned correctly when waveRise=true and waveAnimate=false. The wave will not position correctly without this, but it's not clear why this is actually necessary.
        } else {
            waveGroup.attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(fillPercent) + ')');
        }

        if (params.waveAnimate) animateWave();

        function animateWave() {
            wave.attr('transform', 'translate(' + waveAnimateScale(wave.attr('T')) + ',0)');
            wave.transition()
                .duration(params.waveAnimateTime * (1 - wave.attr('T')))
                .ease('linear')
                .attr('transform', 'translate(' + waveAnimateScale(1) + ',0)')
                .attr('T', 1)
                .each('end', function () {
                    wave.attr('T', 0);
                    animateWave(params.waveAnimateTime);
                });
        }

        function GaugeUpdater() {
            this.update = function (value) {
                let newFinalValue = parseFloat(value).toFixed(2);
                let textRounderUpdater = function (value) { return Math.round(value); };
                if (parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))) {
                    textRounderUpdater = function (value) { return parseFloat(value).toFixed(1); };
                }
                if (parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))) {
                    textRounderUpdater = function (value) { return parseFloat(value).toFixed(2); };
                }

                let textTween = function () {
                    let i = d3.interpolate(this.textContent, parseFloat(value).toFixed(2));
                    return function (t) { this.textContent = textRounderUpdater(i(t)) + percentText; }
                };

                text1.transition()
                    .duration(params.waveRiseTime)
                    .tween("text", textTween);
                text2.transition()
                    .duration(params.waveRiseTime)
                    .tween("text", textTween);

                let fillPercent = Math.max(params.minValue, Math.min(params.maxValue, value)) / params.maxValue;
                let waveHeight = fillCircleRadius * waveHeightScale(fillPercent * 100);
                let waveRiseScale = d3.scale.linear()
                    // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
                    // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
                    // circle at 100%.
                    .range([(fillCircleMargin + fillCircleRadius * 2 + waveHeight), (fillCircleMargin - waveHeight)])
                    .domain([0, 1]);
                let newHeight = waveRiseScale(fillPercent);
                let waveScaleX = d3.scale.linear().range([0, waveClipWidth]).domain([0, 1]);
                let waveScaleY = d3.scale.linear().range([0, waveHeight]).domain([0, 1]);
                let newClipArea;
                if (params.waveHeightScaling) {
                    newClipArea = d3.svg.area()
                        .x(function (d) { return waveScaleX(d.x); })
                        .y0(function (d) { return waveScaleY(Math.sin(Math.PI * 2 * params.waveOffset * -1 + Math.PI * 2 * (1 - params.waveCount) + d.y * 2 * Math.PI)); })
                        .y1(function (d) { return (fillCircleRadius * 2 + waveHeight); });
                } else {
                    newClipArea = clipArea;
                }

                let newWavePosition = params.waveAnimate ? waveAnimateScale(1) : 0;
                wave.transition()
                    .duration(0)
                    .transition()
                    .duration(params.waveAnimate ? (params.waveAnimateTime * (1 - wave.attr('T'))) : (params.waveRiseTime))
                    .ease('linear')
                    .attr('d', newClipArea)
                    .attr('transform', 'translate(' + newWavePosition + ',0)')
                    .attr('T', '1')
                    .each("end", function () {
                        if (params.waveAnimate) {
                            wave.attr('transform', 'translate(' + waveAnimateScale(0) + ',0)');
                            animateWave(params.waveAnimateTime);
                        }
                    });
                waveGroup.transition()
                    .duration(params.waveRiseTime)
                    .attr('transform', 'translate(' + waveGroupXPosition + ',' + newHeight + ')')
            }
        }

        return new GaugeUpdater();
    }


    //generate gauge chart
    service.createGaugeChart = function (targetId, label, size, min, max) {
        let gauges = [];
        let config = {
            size: size,
            label: label,
            min: min ? min : 0,
            max: max ? max : 100,
            minorTicks: 5
        };

        let range = config.max - config.min;
        config.greenZones = [{ from: config.min + range * 0, to: config.min + range * 0.75 }];
        config.yellowZones = [{ from: config.min + range * 0.75, to: config.max }];

        gauges[name] = new Gauge(targetId, config);
        gauges[name].render();

        return gauges;
    }

    service.updateGaugeChart = function (velocity, gauges, targetId) {
        for (let i in gauges) {
            gauges[i].redraw(velocity);
        }
        let gaugelabel = d3.select(targetId);
        gaugelabel.insert('tspan').text(parseFloat(velocity).toFixed(2));
        gaugelabel.insert('tspan').text('m/s').attr('class', 'gauge-sub-title');
    }

    service.createThermometer = function (params) {
        $(params.targetId).html('');

        let bottomY = params.svg_height - 5;
        let mercuryColor = '#e60000';
        let innerBulbColor = '#e6c8c8';
        let tubeBorderColor = "#ffffff";

        let bulb_cy = bottomY - params.bulb_radius;
        let bulb_cx = params.svg_width / 2;
        let top_cy = params.topY + params.tube_width / 2;

        //generate svg
        let svg = d3.select(params.targetId)
            .append("svg")
            .attr("width", params.svg_width)
            .attr("height", params.svg_height)
            .attr("style", params.svg_style);

        let defs = svg.append("defs");

        //Define the radial gradient for the bulb fill colour
        let bulbGradient = defs.append("radialGradient")
            .attr("id", "bulbGradient")
            .attr("cx", "50%")
            .attr("cy", "50%")
            .attr("r", "50%")
            .attr("fx", "50%")
            .attr("fy", "50%");

        bulbGradient.append("stop").attr("offset", "0%").style("stop-color", innerBulbColor);
        bulbGradient.append("stop").attr("offset", "90%").style("stop-color", mercuryColor);

        //top circle
        svg.append("circle")
            .attr("id", "top_circle")
            .attr("r", params.tube_width / 2)
            .attr("cx", params.svg_width / 2)
            .attr("cy", top_cy)
            .style("fill", "#afafaf")
            .style("stroke", tubeBorderColor)
            .style("stroke-width", params.tube_border_width + "px");

        // Rect element for tube
        svg.append("rect")
            .attr("x", params.svg_width / 2 - params.tube_width / 2)
            .attr("y", top_cy)
            .attr("height", bulb_cy - top_cy)
            .attr("width", params.tube_width)
            .style("shape-rendering", "crispEdges")
            .style("fill", "#afafaf")
            .style("stroke", tubeBorderColor)
            .style("stroke-width", params.tube_border_width + "px");

        // White fill for rounded tube top circle element
        // to hide the border at the top of the tube rect element
        svg.append("circle")
            .attr("r", params.tube_width / 2 - params.tube_border_width / 2)
            .attr("cx", params.svg_width / 2)
            .attr("cy", top_cy)
            .style("fill", "#afafaf")
            .style("stroke", "none");

        // Main bulb of thermometer (empty), white fill
        svg.append("circle")
            .attr("r", params.bulb_radius)
            .attr("cx", bulb_cx)
            .attr("cy", bulb_cy)
            .style("fill", "#afafaf")
            .style("stroke", tubeBorderColor)
            .style("stroke-width", params.tube_border_width + "px");

        // Rect element for tube fill colour
        svg.append("rect")
            .attr("x", params.svg_width / 2 - (params.tube_width - params.tube_border_width) / 2)
            .attr("y", top_cy)
            .attr("height", bulb_cy - top_cy)
            .attr("width", params.tube_width - params.tube_border_width)
            .style("shape-rendering", "crispEdges")
            .style("fill", "#afafaf")
            .style("stroke", "none");

        // Scale step size
        let step = 5;

        // Determine a suitable range of the temperature scale
        let domain = [
            step * Math.floor(params.min_temp / step),
            step * Math.ceil(params.max_temp / step)
        ];

        if (params.min_temp - domain[0] < 0.66 * step)
            domain[0] -= step;

        if (domain[1] - params.max_temp < 0.66 * step)
            domain[1] += step;

        // D3 scale object
        let scale = d3.scale.linear().range([bulb_cy - params.bulb_radius / 2 - 8.5, top_cy]).domain(domain);

        // Max and min temperature lines
        [params.min_temp, params.max_temp].forEach(function (t) {
            let isMax = (t == params.max_temp);
            let label = (isMax ? "44℃" : "32℃");
            let textCol = (isMax ? "#ff0000" : "#36caf7");
            let textOffset = (isMax ? -4 : 4);

            svg.append("line")
                .attr("id", label + "Line")
                .attr("x1", params.svg_width / 2 - params.tube_width / 2)
                .attr("x2", params.svg_width / 2 + params.tube_width / 2 + 22)
                .attr("y1", scale(t))
                .attr("y2", scale(t))
                .style("stroke", tubeBorderColor)
                .style("stroke-width", "1px")
                .style("shape-rendering", "crispEdges");

            svg.append("text")
                .attr("x", params.svg_width / 2 + params.tube_width / 2 + 2)
                .attr("y", scale(t) + textOffset)
                .attr("dy", isMax ? null : "0.75em")
                .text(label)
                .style("fill", textCol)
                .style("font-size", "11px");
        });
        let tubeFill_bottom = bulb_cy;
        let tubeFill_top = scale(params.current_temp);

        // Rect element for the red mercury column

        svg.append("rect")
            .attr("id", "thermometer_tube")
            .attr("x", params.svg_width / 2 - (params.tube_width - 10) / 2)
            .attr("y", tubeFill_top)
            .attr("width", params.tube_width - 10)
            // .attr("height", tubeFill_bottom - tubeFill_top)
            .style("shape-rendering", "crispEdges")
            .style("fill", mercuryColor)

        // Main thermometer bulb fill
        svg.append("circle")
            .attr("r", params.bulb_radius - 6)
            .attr("cx", bulb_cx)
            .attr("cy", bulb_cy)
            .style("fill", "url(#bulbGradient)")
            .style("stroke", mercuryColor)
            .style("stroke-width", "2px");

        // Values to use along the scale ticks up the thermometer
        let tickValues = d3.range((domain[1] - domain[0]) / step + 1).map(function (v) { return domain[0] + v * step; });

        // D3 axis object for the temperature scale
        let axis = d3.svg.axis()
            .scale(scale)
            .innerTickSize(7)
            .outerTickSize(0)
            .tickValues(tickValues)
            .orient("left");

        // Add the axis to the image
        let svgAxis = svg.append("g")
            .attr("id", "tempScale")
            .attr("transform", "translate(" + (params.svg_width / 2 - params.tube_width / 2) + ",0)")
            .call(axis);

        // Format text labels
        svgAxis.selectAll(".tick text")
            .style("fill", "#777777")
            .style("font-size", "10px");

        // Set main axis line to no stroke or fill
        svgAxis.select("path")
            .style("stroke", "none")
            .style("fill", "none");

        // Set the style of the ticks
        svgAxis.selectAll(".tick line")
            .style("stroke", tubeBorderColor)
            .style("shape-rendering", "crispEdges")
            .style("stroke-width", "1px");
    }

    service.updateRadialProgress = function (targetId) {
        let radialProgress = d3.select(targetId)
            .attr("width", "%")
            .attr("height", "100px")
            .attr("box-sizing", "border-box")
            .attr("float", "float");

        let _data = null,
            _duration = 1000,
            _selection,
            _margin = { top: 0, right: 0, bottom: 0, left: 0 },
            _width,
            _height,
            __width = 90,
            __height = 90,
            _diameter = 100,
            _label = "",
            _fontSize = 5;

        let _mouseClick;

        let _value = 0,
            _minValue = 0,
            _maxValue = 100;

        let _currentArc = 0, _currentArc2 = 0, _currentValue = 0;

        let _arc = d3.svg.arc()
            .startAngle(0 * (Math.PI / 180)); //just radians

        let _arc2 = d3.svg.arc()
            .startAngle(0 * (Math.PI / 180))
            .endAngle(0); //just radians

        _selection = d3.select(targetId);

        function component() {
            _selection.each(function (data) {
                // Select the svg element, if it exists.
                let svg = d3.select(this).selectAll("svg").data([data]);
                let enter = svg.enter().append("svg").attr("class", "radial-svg").append("g");
                measure();

                svg.attr("width", __width)
                    .attr("height", __height);

                let background = enter.append("g").attr("class", "component")
                //.attr("cursor","pointer")
                //.on("click",onMouseClick);

                _arc.endAngle(360 * (Math.PI / 180))

                background.append("rect")
                    .attr("class", "background")
                    .attr("width", _width)
                    .attr("height", _height);

                background.append("path")
                    .attr("transform", "translate(" + _width / 2 + "," + _width / 2 + ")")
                    .attr("d", _arc);

                background.append("text")
                    .attr("class", "label")
                    .attr("transform", "translate(" + _width / 2 + "," + (_width + _fontSize) + ")")
                    .text(_label);
                let g = svg.select("g")
                    .attr("transform", "translate(" + _margin.left + "," + _margin.top + ")");

                _arc.endAngle(_currentArc);
                enter.append("g").attr("class", "arcs");
                let path = svg.select(".arcs").selectAll(".arc").data(data);
                path.enter().append("path")
                    .attr("class", "arc")
                    .attr("transform", "translate(" + _width / 2 + "," + _width / 2 + ")")
                    .attr("d", _arc);

                //Another path in case we exceed 100%
                let path2 = svg.select(".arcs").selectAll(".arc2").data(data);
                path2.enter().append("path")
                    .attr("class", "arc2")
                    .attr("transform", "translate(" + _width / 2 + "," + _width / 2 + ")")
                    .attr("d", _arc2);


                enter.append("g").attr("class", "labels");
                let label = svg.select(".labels").selectAll(".label").data(data);
                label.enter().append("text")
                    .attr("class", "label")
                    .attr("y", _width / 2 + _fontSize / 3)
                    .attr("x", _width / 2)
                    //.attr("cursor","pointer")
                    .attr("width", _width)
                    // .attr("x",(3*_fontSize/2))
                    .text(function (d) { return Math.round((_value - _minValue) / (_maxValue - _minValue) * 100) + "%" })
                    .style("font-size", _fontSize + "px")
                    .on("click", onMouseClick);

                path.exit().transition().duration(500).attr("x", 1000).remove();
                layout(svg);

                function layout(svg) {
                    let ratio = (_value - _minValue) / (_maxValue - _minValue);
                    let endAngle = Math.min(360 * ratio, 360);
                    endAngle = endAngle * Math.PI / 180;

                    path.datum(endAngle);
                    path.transition().duration(_duration)
                        .attrTween("d", arcTween);

                    if (ratio > 1) {
                        path2.datum(Math.min(360 * (ratio - 1), 360) * Math.PI / 180);
                        path2.transition().delay(_duration).duration(_duration)
                            .attrTween("d", arcTween2);
                    }

                    label.datum(Math.round(ratio * 100));
                    label.transition().duration(_duration)
                        .tween("text", labelTween);
                }
            });

            function onMouseClick(d) {
                if (typeof _mouseClick == "function") {
                    _mouseClick.call();
                }
            }
        }

        function labelTween(a) {
            let i = d3.interpolate(_currentValue, a);
            _currentValue = i(0);

            return function (t) {
                _currentValue = i(t);
                this.textContent = Math.round(i(t)) + "%";
            }
        }

        function arcTween(a) {
            let i = d3.interpolate(_currentArc, a);

            return function (t) {
                _currentArc = i(t);
                return _arc.endAngle(i(t))();
            };
        }

        function arcTween2(a) {
            let i = d3.interpolate(_currentArc2, a);

            return function (t) {
                return _arc2.endAngle(i(t))();
            };
        }


        function measure() {
            _width = _diameter - _margin.right - _margin.left - _margin.top - _margin.bottom;
            _height = _width;
            _fontSize = _width * .2;
            _arc.outerRadius(_width / 2);
            _arc.innerRadius(_width / 2 * .85);
            _arc2.outerRadius(_width / 2 * .85);
            _arc2.innerRadius(_width / 2 * .85 - (_width / 2 * .15));
        }


        component.render = function () {
            measure();
            component();
            return component;
        }

        component.value = function (_) {
            if (!arguments.length) return _value;
            _value = [_];
            _selection.datum([_value]);
            return component;
        }


        component.margin = function (_) {
            if (!arguments.length) return _margin;
            _margin = _;
            return component;
        };

        component.diameter = function (_) {
            if (!arguments.length) return _diameter
            _diameter = _;
            return component;
        };

        component.minValue = function (_) {
            if (!arguments.length) return _minValue;
            _minValue = _;
            return component;
        };

        component.maxValue = function (_) {
            if (!arguments.length) return _maxValue;
            _maxValue = _;
            return component;
        };

        component.label = function (_) {
            if (!arguments.length) return _label;
            _label = _;
            return component;
        };

        component._duration = function (_) {
            if (!arguments.length) return _duration;
            _duration = _;
            return component;
        };

        component.onClick = function (_) {
            if (!arguments.length) return _mouseClick;
            _mouseClick = _;
            return component;
        }

        return component;

    }

    service.createCircularGauge = function (container, configuration) {
        let that = {};
        let config = {
            size: 200,
            clipWidth: 200,
            clipHeight: 110,
            ringInset: 20,
            ringWidth: 20,

            pointerWidth: 10,
            pointerTailLength: 3,
            pointerHeadLengthPercent: 0.6,

            minValue: 0,
            maxValue: 10,

            minAngle: -90,
            maxAngle: 90,

            transitionMs: 750,

            majorTicks: 3,
            labelFormat: d3.format(',g'),
            labelInset: 20,

            arcColorFn: d3.interpolateHsl(d3.rgb('#faff00'), d3.rgb('#ff0000'))
        };

        let range = undefined;
        let r = undefined;
        let pointerHeadLength = undefined;
        let value = 0;

        let svg = undefined;
        let arc = undefined;
        let scale = undefined;
        let ticks = undefined;
        let tickData = undefined;
        let pointer = undefined;

        let donut = d3.layout.pie();

        function deg2rad(deg) {
            return deg * Math.PI / 180;
        }
        function newAngle(d) {
            let ratio = scale(d);
            let newAngle = config.minAngle + (ratio * range);
            return newAngle;
        }

        function configure(configuration) {
            let prop = undefined;
            for (prop in configuration) {
                config[prop] = configuration[prop];
            }

            range = config.maxAngle - config.minAngle;
            r = config.size / 2;
            pointerHeadLength = Math.round(r * config.pointerHeadLengthPercent);

            // a linear scale that maps domain values to a percent from 0..1
            scale = d3.scale.linear()
                .range([0, 1])
                .domain([config.minValue, config.maxValue]);

            ticks = scale.ticks(config.majorTicks);
            tickData = d3.range(config.majorTicks).map(function () { return 1 / config.majorTicks; });

            arc = d3.svg.arc()
                .innerRadius(r - config.ringWidth - config.ringInset)
                .outerRadius(r - config.ringInset)
                .startAngle(function (d, i) {
                    let ratio = d * i;
                    return deg2rad(config.minAngle + (ratio * range));
                })
                .endAngle(function (d, i) {
                    let ratio = d * (i + 1);
                    return deg2rad(config.minAngle + (ratio * range));
                });
        }
        that.configure = configure;

        function centerTranslation() {
            return 'translate(' + r + ',' + r + ')';
        }

        function isRendered() {
            return (svg !== undefined);
        }
        that.isRendered = isRendered;

        function render(newValue) {
            svg = d3.select(container)
                .append('svg:svg')
                .attr('class', 'gauge')
                .attr('width', config.clipWidth)
                .attr('height', config.clipHeight);

            let centerTx = centerTranslation();

            let arcs = svg.append('g')
                .attr('class', 'arc')
                .attr('transform', centerTx);

            arcs.selectAll('path')
                .data(tickData)
                .enter().append('path')
                .attr('fill', function (d, i) { return config.arcColorFn(d * i); })
                .attr('d', arc);

            let lg = svg.append('g')
                .attr('class', 'label')
                .attr('transform', centerTx);
            lg.selectAll('text')
                .data(ticks)
                .enter().append('text')
                .attr('transform', function (d) {
                    let ratio = scale(d);
                    let newAngle = config.minAngle + (ratio * range);
                    return 'rotate(' + newAngle + ') translate(0,' + (config.labelInset - r - 5) + ')';
                })
                .text(config.labelFormat);

            let lineData = [[config.pointerWidth / 2, 0],
            [0, -pointerHeadLength],
            [-(config.pointerWidth / 2), 0],
            [0, config.pointerTailLength],
            [config.pointerWidth / 2, 0]];
            let pointerLine = d3.svg.line().interpolate('monotone');
            let pg = svg.append('g').data([lineData])
                .attr('class', 'pointer')
                .attr('transform', centerTx);

            pointer = pg.append('path')
                .attr('d', pointerLine/*function(d) { return pointerLine(d) +'Z';}*/)
                .attr('transform', 'rotate(' + config.minAngle + ')');
            update(newValue === undefined ? 0 : newValue);
        }
        that.render = render;

        function update(newValue, newConfiguration) {
            if (newConfiguration !== undefined) {
                configure(newConfiguration);
            }
            let ratio = scale(newValue);
            let newAngle = config.minAngle + (ratio * range);
            pointer.transition()
                .duration(config.transitionMs)
                .ease('elastic')
                .attr('transform', 'rotate(' + newAngle + ')');
        }
        that.update = update;

        configure(configuration);

        return that;
    }

    service.createStackedBarChartHoriz = function (targetId, dataset, containerWidth, containerHeight, margins) {
        if (!margins) {
            margins = {
                top: 12,
                left: 48,
                right: 24,
                bottom: 24
            };
        }

        let width = (containerWidth || 190) - margins.left - margins.right;
        let height = (containerHeight || 100) - margins.top - margins.bottom;

        dataset = dataset.map(function (d) {
            return d.data.map(function (o, i) {
                // Structure it so that your numeric
                // axis (the stacked amount) is y
                return {
                    y: o.count,
                    x: o.title
                };
            });
        });

        let stack = d3.layout.stack();
        stack(dataset);

        dataset = dataset.map(function (group) {
            return group.map(function (d) {
                // Invert the x and y values, and y0 becomes x0
                return {
                    x: d.y,
                    y: d.x,
                    x0: d.y0
                };
            });
        });

        let svg = d3.select(targetId)
            .append('svg')
            .attr('width', width + margins.left + margins.right)
            .attr('height', height + margins.top + margins.bottom)
            .append('g')
            .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');
        let xMax = d3.max(dataset, function (group) {
            return d3.max(group, function (d) {
                return d.x + d.x0;
            });
        });

        let xScale = d3.scale.linear()
            .domain([0, xMax])
            .range([0, width]);
        let titles = dataset[0].map(function (d) {
            return d.y;
        });

        let yScale = d3.scale.ordinal()
            .domain(titles)
            .rangeRoundBands([0, height], .1);

        let xAxis = d3.svg.axis()
            .scale(xScale)
            .orient('bottom');

        let yAxis = d3.svg.axis()
            .scale(yScale)
            .orient('left');

        let colours = d3.scale.category10();

        let groups = svg.selectAll('g')
            .data(dataset)
            .enter()
            .append('g')
            .style('fill', function (d, i) { return colours(i); });

        let rects = groups.selectAll('rect')
            .data(function (d) { return d; })
            .enter()
            .append('rect')
            .attr('x', function (d) { return xScale(d.x0); })
            .attr('y', function (d, i) { return yScale(d.y); })
            .attr('height', function (d) { return yScale.rangeBand(); })
            .attr('width', function (d) { return xScale(d.x); })
            .on('mouseover', function (d) {
                let xPos = parseFloat(d3.select(this).attr('x')) / 2 + width / 2;
                let yPos = parseFloat(d3.select(this).attr('y')) + yScale.rangeBand() / 2;

                let text;
                if (d.y == 'Success') {
                    if (d.x0 == 0) {
                        text = '성공 : ' + d.x + '%';
                    } else {
                        text = '실패 : ' + d.x + '%';
                    }
                } else {
                    if (d.x0 == 0) {
                        text = '오른발 : ' + d.x;
                    } else {
                        text = '왼발 : ' + d.x;
                    }
                }
                d3.select('#tooltip')
                    .style('left', xPos + 'px')
                    .style('top', yPos + 'px')
                    .style('font-size', '16px')
                    .select('#value')
                    .text(text);

                d3.select('#tooltip').classed('hidden', false);
            })
            .on('mouseout', function () { d3.select('#tooltip').classed('hidden', true); });


        //   svg.append('g')
        //      .attr('class', 'axis')
        //      .attr('transform', 'translate(0,' + height + ')')
        //      .call(xAxis);

        svg.append('g')
            .attr('class', 'axis')
            .call(yAxis);

        d3.selectAll('g.tick > text')
            .style('font-size', '16px');
    }

    service.createStackedBarChartHorizAnalysis = function (targetId, dataset, containerWidth, containerHeight, margins) {
        if (!margins) {
            if (dataset.length === 7) {
                margins = {
                    top: 10,
                    left: 80,
                    right: 24,
                    bottom: 10
                };
            } else {
                margins = {
                    top: 20,
                    left: 80,
                    right: 24,
                    bottom: 24
                };
            }
        }

        let width = (containerWidth || 170) - margins.left - margins.right;
        let height = (containerHeight || 190) - margins.top - margins.bottom;

        if (dataset.length === 7) {
            height = (containerHeight || 170) - margins.top - margins.bottom;
        }

        dataset = dataset.map(function (d) {
            return d.data.map(function (o, i) {
                // Structure it so that your numeric
                // axis (the stacked amount) is y
                return {
                    y: o.count,
                    x: o.title
                };
            });
        });

        let stack = d3.layout.stack();
        stack(dataset);

        dataset = dataset.map(function (group) {
            return group.map(function (d) {
                // Invert the x and y values, and y0 becomes x0
                return {
                    x: d.y,
                    y: d.x,
                    x0: d.y0
                };
            });
        });

        let svg = d3.select(targetId)
            .append('svg')
            .attr('width', width + margins.left + margins.right)
            .attr('height', height + margins.top + margins.bottom)
            .append('g')
            .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');
        let xMax = d3.max(dataset, function (group) {
            return d3.max(group, function (d) {
                return d.x + d.x0;
            });
        });

        let xScale = d3.scale.linear()
            .domain([0, xMax])
            .range([0, width]);
        let titles = dataset[0].map(function (d) {
            return d.y;
        });

        let yScale = d3.scale.ordinal()
            .domain(titles)
            .rangeRoundBands([0, height], .1);

        let xAxis = d3.svg.axis()
            .scale(xScale)
            .orient('bottom');

        let yAxis = d3.svg.axis()
            .scale(yScale)
            .orient('left');

        let colours = d3.scale.category10();

        let groups = svg.selectAll('g')
            .data(dataset)
            .enter()
            .append('g');

        let rects = groups.selectAll('rect')
            .data(function (d) { return d; })
            .enter()
            .append('rect')
            .attr('x', function (d) { return xScale(d.x0); })
            .attr('y', function (d, i) { return yScale(d.y); })
            .attr('height', function (d) { return yScale.rangeBand(); })
            .attr('width', function (d) { return xScale(d.x); })
            .style('fill', function (d, i) {
                // 왼발, 오른발 색상 / 인사이드, 아웃사이드, 인스텝 색상 다르게 처리
                if (i < 2) {
                    return colours(0);
                } else {
                    return colours(1);
                }
            });


        //   svg.append('g')
        //      .attr('class', 'axis')
        //      .attr('transform', 'translate(0,' + height + ')')
        //      .call(xAxis);

        svg.append('g')
            .attr('class', 'axis')
            .call(yAxis);
    }

    service.createStackedBarChart = function (targetId, dataset, containerWidth, containerHeight, margin) {
        if (!containerWidth) {
            containerWidth = document.getElementById(targetId.substr(1)).clientWidth;
        }

        if (!containerHeight) {
            containerHeight = document.getElementById(targetId.substr(1)).clientHeight;
        }

        if (!margin) {
            margin = {
                top: 12,
                left: 10,
                right: 10,
                bottom: 20
            };
        }

        let width = (containerWidth || 190) - margin.left - margin.right;
        let height = (containerHeight || 100) - margin.top - margin.bottom;
        
        let data = [
            { title: '패스', A: dataset.total },     // stack 을 사용할 경우 데이터는 { title: '패스', A: 10, B: 20 } 이런 형태로 사용해야함
            { title: '성공', A: dataset.success },
            { title: '오른발', A: dataset.right },
            { title: '왼발', A: dataset.left },
        ];

        let xData = ["A"];      // stack 을 사용할 경우 ["A", "B"] 이런 형태로 사용해야함

        let x = d3.scale.ordinal()
            .rangeRoundBands([0, width], 0.35);
        let y = d3.scale.linear()
            .rangeRound([height, 0]);

        //let color = d3.scale.category20();
        let color = d3.scale.category10();
        let colorArr = ['#26ff00', '#ffd000'];

        let xAxis = d3.svg.axis()
            .scale(x)
            .orient("bottom");

        let svg = d3.select(targetId).append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(10,10)");
        //   .attr("transform", `translate(${margin.left},${margin.top})`);

        let dataIntermediate = xData.map(function (c) {
            return data.map(function (d) {
                return { x: d.title, y: d[c] };
            });
        });

        let dataStackLayout = d3.layout.stack()(dataIntermediate);

        x.domain(dataStackLayout[0].map(function (d) {
            return d.x;
        }));

        y.domain([0,
            d3.max(dataStackLayout[dataStackLayout.length - 1],
                function (d) { return d.y0 + d.y; })
        ]).nice();

        let layer = svg.selectAll(".stack")
            .data(dataStackLayout)
            .enter().append("g")
            .attr("class", "stack")
            .style("fill", function (d, i) {
                return colorArr[i];
                //  return color(i);
            });

        layer.selectAll("rect")
            .data(function (d) {
                return d;
            })
            .enter().append("rect")
            .attr("x", function (d) {
                return x(d.x);
            })
            .attr("y", function (d) {
                return y(d.y + d.y0);
            })
            .attr("height", function (d) {
                return y(d.y0) - y(d.y + d.y0);
            })
            .attr("width", x.rangeBand())
            .style("fill", function (d, i) {    // stack 을 사용한다면 이 부분을 주석처리해야 함
                return color(i % 2);
            });

        svg.append("g")
            .attr("class", "axis")
            .attr("transform", "translate(0," + height + ")")
            .call(xAxis);
    }

    service.createBarChartBasic = function (targetId, type) {
        //   let data = d3.range(90).map(function(){
        //       return Math.random();
        //   });

        var params;
        if (type === 'positive') {
            params = 'bar_team_home';
        } else {
            params = 'bar_team_away';
        }

        $http.get('http://localhost:3000/api/sgs/' + params).then(function (result) {
            console.log(params + ' ... ', result.data)
            let data = result.data;

            let height = 30;
            let width = 1000;
            let barPadding = 2;
            let barWidth = (width / data.length) - barPadding;

            let yScale = d3.scale.linear().domain([0, d3.max(data)]).range([0, height]);
            let xScale = d3.scale.ordinal().domain(data).rangeBands([0, width], 0.1, 0.3);

            let svg = d3.select(targetId)
                .style("width", width + 'px')
                .style("height", height + 'px');

            svg.selectAll('rect')
                .data(data)
                .enter()
                .append('rect')
                .on('click', function (d) {
                    d3.selectAll('.bar').style("fill", "green"); // not work
                    d3.select(this).style("fill", "magenta");
                })
                .attr('class', 'bar')
                .attr("x", function (d, i) {
                    return xScale(d);
                })
                .attr("y", function (d, i) {
                    return height;
                })
                .attr("width", function (d, i) {
                    return xScale.rangeBand();
                })
                .attr("fill", function (d, i) {
                    //  return 'rgb(256, ' + Math.round(i / 2) + ', ' + i + ')';
                    return 'green';
                })
                .attr("height", 0)
                .transition()
                .duration(200)
                .delay(function (d, i) {
                    return i * 0;
                })
                .attr("y", function (d, i) {
                    if (type == 'positive') {
                        return height - yScale(d);
                    } else {
                        return yScale(d) - height;
                    }
                })
                .attr("height", function (d, i) {
                    if (type == 'positive') {
                        return yScale(d);
                    } else {
                        return height;
                    }
                })



        });


    }

    service.createWeightChart = function (targetId, label, size, min, max) {
        console.log(arguments);
    };

    service.updateWeightChart0 = function (velocity, gauges, targetId) {
        $('#' + targetId).highcharts({
            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                margins: [0, 0, 0, 0],
                spacingTop: 20,
                spacingBottom: 0
            },
            title: {
                text: ''
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            xAxis: {
                title: '',
                gridLineWidth: 0,
                categories: ['목표', '현재'],
                labels: {
                    style: {
                        color: '#fff'
                    }
                }
            },
            yAxis: {
                title: '',
                gridLineWidth: 0
            },
            series: [{
                data: [{
                    color: 'blue',
                    y: +velocity.target
                }, {
                    color: 'red',
                    y: +velocity.current
                }]
            }]
        });
    };

    service.updateWeightChart = function (velocity, gauges, targetId) {
        $('#' + targetId).highcharts({
            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                margins: [0, 0, 0, 0],
                spacingTop: 20,
                spacingBottom: 0
            },
            title: {
                text: ''
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            xAxis: {
                enabled: false,
                title: '',
                gridLineWidth: 0,
                // categories: ['현재'],
                // labels: {
                //     style: {
                //         color: '#fff'
                //     }
                // }
            },
            yAxis: {
                title: '',
                gridLineWidth: 0,
                plotLines: [{
                    value: +velocity.target,
                    color: '#fff',
                    width: 2,
                    zIndex: 4,
                    label: {
                        align: 'left',
                        text: '목표',
                        style: {
                            color: '#fff'
                        }
                    }
                }]
            },
            series: [{
                data: [{
                    color: 'red',
                    y: +velocity.current
                }]
            }]
        });
    };

    service.updateWeightChart2 = function (velocity, gauges, targetId) {
        //-------------------------------------------------------
        Highcharts.Renderer.prototype.symbols.line = function (x, y, width, height) {
            return ['M', x, y + width / 2, 'L', x + height, y + width / 2];
        };
        //-------------------------------------------------------
        Highcharts.setOptions({
            chart: {
                type: 'bar',
                margins: [0, 0, 0, 0],
                backgroundColor: 'transparent'
            },
            credits: { enabled: false },
            exporting: { enabled: false },
            legend: { enabled: false },
            title: { text: '' },
            xAxis: {
                tickLength: 0,
                lineColor: '#999',
                lineWidth: 1,
                labels: { style: { fontWeight: 'bold' } }
            },
            yAxis: {
                min: 0,
                minPadding: 0,
                maxPadding: 0,
                tickColor: '#ccc',
                tickWidth: 0,
                tickLength: 0,
                gridLineWidth: 0,
                endOnTick: true,
                title: { text: '' },
                labels: {
                    y: 10,
                    style: {
                        fontSize: '10px',
                        color: '#fff'
                    },
                    formatter: function () {
                        if (this.isLast) {
                            return '목표';
                        }
                        else {
                            return '';
                        }
                    }
                }
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    color: 'red',
                    shadow: false,
                    borderWidth: 0,
                },
                scatter: {
                    marker: {
                        symbol: 'line',
                        lineWidth: 3,
                        radius: 8,
                        lineColor: 'red'
                    }
                }
            }
        });

        var chart1 = new Highcharts.Chart({
            chart: { renderTo: targetId },
            xAxis: { categories: ['현재'] },
            yAxis: {
                max: 100,
                labels: { y: 10, style: { fontSize: '8px' } },
                plotBands: [{ from: 0, to: +velocity.target, color: 'rgba(103,103,103,.35)' }]
            },
            series: [{ name: 'Measure', pointWidth: 10, data: [+velocity.current] }]
        });
    };

    service.generateVariableRadiusChart = function(options, category, update) {
        var seriesData = [];
        var values = [];
        var items = angular.copy(category.items);
        items.shift();
        _.forEach(items, function(item, i) {
            if (item.name === '워킹') {
                item.name = 'Walking';
            } else if (item.name === '스프린트') {
                item.name = 'Sprint';
            } else if (item.name === '러닝') {
                item.name = 'Running';
            } else if (item.name === '점프') {
                item.name = 'Jump';
            } else if (item.name === '턴') {
                item.name = 'Turn';
            } else if (item.name === '땅볼') {
                item.name = 'Ground Ball';
            } else if (item.name === '가슴') {
                item.name = 'Chest';
            } else if (item.name === '허벅지') {
                item.name = 'Thigh';
            } else if (item.name === '이동') {
                item.name = 'Movement';
            } else if (item.name === '공중볼') {
                item.name = 'Air Ball';
            } else if (item.name === '팬텀') {
                item.name = 'Phantom';
            } else if (item.name === '크루이프턴') {
                item.name = 'Cruyff Turn';
            } else if (item.name === '페인팅') {
                item.name = 'Painting';
            } else if (item.name === '스텝오버') {
                item.name = 'Stepover';
            } else if (item.name === '볼터치') {
                item.name = 'Ball Touch';
            } else if (item.name === '직진') {
                item.name = 'Direct';
            } else if (item.name === '논스톱') {
                item.name = 'Nonstop';
            } else if (item.name === '스루') {
                item.name = 'Through';
            } else if (item.name === '원터치') {
                item.name = 'Onetouch';
            } else if (item.name === '위협') {
                item.name = 'Threat';
            } else if (item.name === '헤딩') {
                item.name = 'Header';
            } else if (item.name === '파넨카') {
                item.name = 'Panenka';
            } else if (item.name === '다이렉트') {
                item.name = 'Direct';
            } else if (item.name === '짧은') {
                item.name = 'Short';
            } else if (item.name === '레이트') {
                item.name = 'Late';
            } else if (item.name === '컷백') {
                item.name = 'Cutback';
            } else if (item.name === '얼리') {
                item.name = 'Early';
            }

            seriesData.push({
                name: item.name,
                y: item.value,
                z: item.value
            });
            values.push(item.value);
        });
        // 모든 값이 0 이면 차트를 그리지 않음
        if (_.max(values) === 0) {
            $('#' + options.containerId).html('&nbsp;');
            return;
        }
        seriesData = _.orderBy(seriesData, ['y', 'z'], ['desc', 'desc']);
console.log('category', category);
console.log('series data', seriesData);
        // 공간 부족을 고려하여 차트에 이름은 3개까지 표시
        _.forEach(seriesData, function(item, i) {
            if (i >= 3) {
                item.name = '';
            }
        });
        if (update) {
            var chart = $('#' + options.containerId).highcharts();
            if (!chart || !chart.series || !chart.series.length) {
                update = false;
            }
        }
        // 데이터 업데이트
        if (update) {
            var chart = $('#' + options.containerId).highcharts();
            chart.series[0].update({
                data: seriesData
            }, true);
        }
        // 차트 새로생성
        else {
            Highcharts.chart(options.containerId, {
                chart: {
                    type: 'variablepie',
                    backgroundColor: 'transparent',
                    width: options.width,
                    height: options.height,
                    margin: [0, 20, 0, 20],
                    spacing: [0, 0, 0, 0]
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    variablepie: {
                        dataLabels: {
                            distance: -30
                        },
                        size: '130%'
                    }
                },
                series: [{
                    minPointSize: 10,
                    innerSize: '20%',
                    zMin: 0,
                    name: 'countries',
                    data: seriesData
                }]
            });
        }       
    };
    service.generateDeviceVariableRadiusChart = function(options, category, update) {
        var seriesData = [];
        var values = [];
        var items = angular.copy(category.items);
        items.shift();
        _.forEach(items, function(item, i) {
            seriesData.push({
                name: '',
                y: item.value,
                z: item.value
            });
            values.push(item.value);
        });
        // 모든 값이 0 이면 차트를 그리지 않음
        if (_.max(values) === 0) {
            $('#' + options.containerId).html('&nbsp;');
            return;
        }
        seriesData = _.orderBy(seriesData, ['y', 'z'], ['desc', 'desc']);
        _.forEach(items, function(item, i) {
            if (i < 3) {
                seriesData[i].name = item.name;
            }
        });
        if (update) {
            var chart = $('#' + options.containerId).highcharts();
            if (!chart || !chart.series || !chart.series.length) {
                update = false;
            }
        }
        // 데이터 업데이트
        if (update) {
            var chart = $('#' + options.containerId).highcharts();
            chart.series[0].update({
                data: seriesData
            }, true);
        }
        // 차트 새로생성
        else {
            Highcharts.chart(options.containerId, {
                chart: {
                    type: 'variablepie',
                    backgroundColor: 'transparent',
                    width: options.width,
                    height: options.height,
                    margin: [0, 20, 0, 20],
                    spacing: [0, 0, 0, 0]
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    variablepie: {
                        dataLabels: {
                            distance: -30
                        },
                        size: '130%'
                    }
                },
                series: [{
                    minPointSize: 10,
                    innerSize: '20%',
                    zMin: 0,
                    name: 'countries',
                    data: seriesData
                }]
            });
        }       
    };
    service.generateActivityChart = function(options, category, item) {
        Highcharts.chart(options.containerId, {
        
            chart: {
                type: 'solidgauge',
                backgroundColor: 'transparent',
                width: options.width,
                height: options.height,
                margin: [0, 20, 0, 20],
                spacing: [0, 0, 0, 0]
            },
            credits: {
                enabled: false
            },
        
            title: {
                text: '',
                style: {
                    fontSize: '24px'
                }
            },
        
            tooltip: {
                enabled: false,
                borderWidth: 0,
                backgroundColor: 'none',
                shadow: false,
                style: {
                    fontSize: '16px'
                },
                pointFormat: '<span style="color:#fff;">{series.name}</span><br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
                positioner: function (labelWidth, labelHeight) {
                    return {
                        x: (this.chart.chartWidth + 50 * 2) / 2,
                        y: (this.chart.plotHeight / 2) - (50 / 2)
                    };
                }
            },
        
            pane: {
                startAngle: 0,
                endAngle: 360,
                background: [{ // Track for Move
                    outerRadius: '116%',
                    innerRadius: '92%',
                    backgroundColor: Highcharts.Color(Highcharts.getOptions().colors[0])
                        .setOpacity(0.3)
                        .get(),
                    borderWidth: 0
                }, { // Track for Exercise
                    outerRadius: '91%',
                    innerRadius: '67%',
                    backgroundColor: Highcharts.Color(Highcharts.getOptions().colors[1])
                        .setOpacity(0.3)
                        .get(),
                    borderWidth: 0
                }, { // Track for Stand
                    outerRadius: '66%',
                    innerRadius: '42%',
                    backgroundColor: Highcharts.Color(Highcharts.getOptions().colors[2])
                        .setOpacity(0.3)
                        .get(),
                    borderWidth: 0
                }]
            },
        
            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                tickPositions: []
            },
        
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        enabled: false
                    },
                    linecap: 'round',
                    stickyTracking: false,
                    rounded: true
                }
            },
        
            series: [{
                name: '심박수',
                data: [{
                    color: Highcharts.getOptions().colors[0],
                    radius: '116%',
                    innerRadius: '92%',
                    y: 80
                }]
            }, {
                name: '체온',
                data: [{
                    color: Highcharts.getOptions().colors[1],
                    radius: '91%',
                    innerRadius: '67%',
                    y: 65
                }]
            }, {
                name: '산소포화도',
                data: [{
                    color: Highcharts.getOptions().colors[2],
                    radius: '66%',
                    innerRadius: '42%',
                    y: 50
                }]
            }]
        }, function(chart) { // on complete
            $('#' + options.containerId + '-centerText').remove();
            var textX = chart.plotLeft + (chart.plotWidth  * 0.5);
            var textY = chart.plotTop  + (chart.plotHeight * 0.5);
    
            var span = '<span id="' + options.containerId + '-centerText" class="' + (item ? item.name : '') + '" style="position:absolute; text-align:center;">';
            span += '<span style="font-size: 20px; line-height:26px;"></span><br>';
            span += '</span>';
    
            $('#' + options.containerId).find('.highcharts-container').append(span);
            span = $('#' + options.containerId + '-centerText');
            // span.css('left', textX + (span.width() * -0.5));
            span.css('left', '58.5px');
            span.css('top', textY + (span.height() * -0.5));
            span.css('width', '86px');
            setTimeout(function() {
                if (!$('#' + options.containerId + '-centerText').children('span').html()) {
                    $('#' + options.containerId + '-centerText').children('span').html('77');
                }
            }, 1000);
        });
    };
    service.createScatterPlot = function(options, category, categoryItem, update) {
        // console.log('category', category);
        
        // if ($('#' + options.containerId).highcharts()) {
        //     return;
        // }
        var items = $.extend(true, [], category.items);
        items.shift();  // 맨 앞은 분류라서 삭제
        if (categoryItem) {
            items = _.filter(items, {
                name: categoryItem.name
            });
        }
        var seriesData = [];
        _.forEach(items, function(item, i) {
            var data = [],
                color;
            _.forEach(item.data, function(item2) {
                data.push([+(new Date(item2.datetime)) + (540 * 60 * 1000), item2.value]);
            });
            if (i === 0) {
                color = 'rgba(223, 83, 83, .5)';
            } else if (i === 1) {
                color = 'rgba(119, 152, 191, .5)';
            } else {
                color = new Highcharts.Color(Highcharts.getOptions().colors[i]).setOpacity(0.66).get();
            }
            seriesData.push({
                name: item.name,
                color: color,
                data: data
            });
        });
        if (update) {
            var chart = $('#' + options.containerId).highcharts();
            if (!chart || !chart.series || !chart.series.length) {
                update = false;
            }
        }
        // 데이터 업데이트
        if (update) {
            var chart = $('#' + options.containerId).highcharts();
            _.forEach(chart.series, function(series, i) {
                if (seriesData && seriesData[i] && seriesData[i].name) {
                    series.update({
                        name: seriesData[i].name,
                        color: seriesData[i].color,
                        data: seriesData[i].data
                    }, false);
                }
            });
            chart.redraw();
        }
        // 차트 새로생성
        else {
            Highcharts.chart(options.containerId, {
                chart: {
                    type: 'scatter',
                    zoomType: 'xy',
                    height: 120,
                    margin: [0, 10, 70, 10],
                    backgroundColor: 'transparent'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    type: 'datetime',
                    labels: {
                        // format: '{value:%m-%e %H:%M}',
                        format: '{value:%m-%d %H:%M}',
                        style: {
                            color: '#ccc',
                            fontSize: '8px',
                            textOverflow: 'none'
                        },
                        rotation: -45
                    },
                    gridLineWidth: 0,
                    lineColor: '#aaa',
                    tickColor: '#aaa',
                    tickLength: 3,
                    title: {
                        enabled: false
                    }
                },
                yAxis: {
                    lineColor: '#aaa',
                    tickColor: '#aaa',
                    gridLineWidth: 0,
                    lineWidth: 0,
                    tickLength: 3,
                    title: {
                        enabled: false
                    },
                    labels: {
                        enabled: false
                    }
                },
                legend: {
                    enabled: false,
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'top',
                    x: 100,
                    y: 70,
                    floating: true,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
                    borderWidth: 1
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    pointFormat: '{point.y}'
                },
                series: seriesData
                // series: [{
                //     name: 'Female',
                //     color: 'rgba(223, 83, 83, .5)',
                //     data: [[161.2, 51.6], [167.5, 59.0], [159.5, 49.2], [157.0, 63.0], [155.8, 53.6],
                //         [170.0, 59.0], [159.1, 47.6], [166.0, 69.8], [176.2, 66.8], [160.2, 75.2],
                //         [172.5, 55.2], [170.9, 54.2], [172.9, 62.5], [153.4, 42.0], [160.0, 50.0],
                //         [147.2, 49.8], [168.2, 49.2], [175.0, 73.2], [157.0, 47.8], [167.6, 68.8],
                //         [159.5, 50.6], [175.0, 82.5], [166.8, 57.2], [176.5, 87.8], [170.2, 72.8],
                //         [174.0, 54.5], [173.0, 59.8], [179.9, 67.3], [170.5, 67.8], [160.0, 47.0],
                //         [154.4, 46.2], [162.0, 55.0], [176.5, 83.0], [160.0, 54.4], [152.0, 45.8],
                //         [162.1, 53.6], [170.0, 73.2], [160.2, 52.1], [161.3, 67.9], [166.4, 56.6],
                //         [168.9, 62.3], [163.8, 58.5], [167.6, 54.5], [160.0, 50.2], [161.3, 60.3],
                //         [167.6, 58.3], [165.1, 56.2], [160.0, 50.2], [170.0, 72.9], [157.5, 59.8],
                //         [167.6, 61.0], [160.7, 69.1], [163.2, 55.9], [152.4, 46.5], [157.5, 54.3]]
            
                // }, {
                //     name: 'Male',
                //     color: 'rgba(119, 152, 191, .5)',
                //     data: [[174.0, 65.6], [175.3, 71.8], [193.5, 80.7], [186.5, 72.6], [187.2, 78.8],
                //         [181.5, 74.8], [184.0, 86.4], [184.5, 78.4], [175.0, 62.0], [184.0, 81.6],
                //         [180.0, 76.6], [177.8, 83.6], [192.0, 90.0], [176.0, 74.6], [174.0, 71.0],
                //         [184.0, 79.6], [192.7, 93.8], [171.5, 70.0], [173.0, 72.4], [176.0, 85.9],
                //         [176.0, 78.8], [180.5, 77.8], [172.7, 66.2], [176.0, 86.4], [173.5, 81.8],
                //         [178.0, 89.6], [180.3, 82.8], [180.3, 76.4], [164.5, 63.2], [173.0, 60.9],
                //         [183.5, 74.8], [175.5, 70.0], [188.0, 72.4], [189.2, 84.1], [172.8, 69.1],
                //         [170.0, 59.5], [182.0, 67.2], [170.0, 61.3], [177.8, 68.6], [184.2, 80.1],
                //         [186.7, 87.8], [171.4, 84.7], [172.7, 73.4], [175.3, 72.1], [180.3, 82.6]]
                // }]
            });
        }
    };

    service.createScatterPlotAnalysis = function(options, category, categoryItem, update) {
        // console.log('category', category);
        
        // if ($('#' + options.containerId).highcharts()) {
        //     return;
        // }

        var items = $.extend(true, [], category.items);
        items.shift();  // 맨 앞은 분류라서 삭제

        if (categoryItem) {
            items = _.filter(items, {
                name: categoryItem.name
            });
        }

        var seriesData = [];

        _.forEach(items, function(item, i) {
            var data = [],
                color;

            _.forEach(item.data, function(item2) {
                if (category.title === '동작') {    // 동작 차트의 경우 최근 1일 이내의 데이터를 보여줌
                    if (+(new Date()) - +(new Date(item2.datetime)) + (540 * 60 * 1000) < 86400000) {
                        data.push([+(new Date(item2.datetime)) + (540 * 60 * 1000), item2.value]);
                    }
                } else {
                    data.push([+(new Date(item2.datetime)) + (540 * 60 * 1000), item2.value]);
                }
            });

            if (i === 0) {
                color = 'rgba(223, 83, 83, .5)';
            } else if (i === 1) {
                color = 'rgba(119, 152, 191, .5)';
            } else {
                color = new Highcharts.Color(Highcharts.getOptions().colors[i]).setOpacity(0.66).get();
            }

            seriesData.push({
                name: item.name,
                color: color,
                data: data
            });
        });

        if (update) {
            var chart = $('#' + options.containerId).highcharts();

            if (!chart || !chart.series || !chart.series.length) {
                update = false;
            }
        }

        // 데이터 업데이트
        if (update) {
            var chart = $('#' + options.containerId).highcharts();

            _.forEach(chart.series, function(series, i) {
                if (seriesData && seriesData[i] && seriesData[i].name) {
                    series.update({
                        name: seriesData[i].name,
                        color: seriesData[i].color,
                        data: seriesData[i].data
                    }, false);
                }
            });

            chart.redraw();
        }
        // 차트 새로생성
        else {
            Highcharts.chart(options.containerId, {
                chart: {
                    type: 'scatter',
                    zoomType: 'xy',
                    height: 120,
                    margin: [0, 10, 70, 10],
                    backgroundColor: 'transparent'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    type: 'datetime',
                    labels: {
                        // format: '{value:%m-%e %H:%M}',
                        format: '{value:%m-%d %H:%M}',
                        style: {
                            color: '#ccc',
                            fontSize: '8px',
                            textOverflow: 'none'
                        },
                        rotation: -45
                    },
                    gridLineWidth: 0,
                    lineColor: '#aaa',
                    tickColor: '#aaa',
                    tickLength: 3,
                    title: {
                        enabled: false
                    }
                },
                yAxis: {
                    lineColor: '#aaa',
                    tickColor: '#aaa',
                    gridLineWidth: 0,
                    lineWidth: 0,
                    tickLength: 3,
                    title: {
                        enabled: false
                    },
                    labels: {
                        enabled: false
                    }
                },
                legend: {
                    enabled: false,
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'top',
                    x: 100,
                    y: 70,
                    floating: true,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
                    borderWidth: 1
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    pointFormat: '{point.y}'
                },
                series: seriesData
                // series: [{
                //     name: 'Female',
                //     color: 'rgba(223, 83, 83, .5)',
                //     data: [[161.2, 51.6], [167.5, 59.0], [159.5, 49.2], [157.0, 63.0], [155.8, 53.6],
                //         [170.0, 59.0], [159.1, 47.6], [166.0, 69.8], [176.2, 66.8], [160.2, 75.2],
                //         [172.5, 55.2], [170.9, 54.2], [172.9, 62.5], [153.4, 42.0], [160.0, 50.0],
                //         [147.2, 49.8], [168.2, 49.2], [175.0, 73.2], [157.0, 47.8], [167.6, 68.8],
                //         [159.5, 50.6], [175.0, 82.5], [166.8, 57.2], [176.5, 87.8], [170.2, 72.8],
                //         [174.0, 54.5], [173.0, 59.8], [179.9, 67.3], [170.5, 67.8], [160.0, 47.0],
                //         [154.4, 46.2], [162.0, 55.0], [176.5, 83.0], [160.0, 54.4], [152.0, 45.8],
                //         [162.1, 53.6], [170.0, 73.2], [160.2, 52.1], [161.3, 67.9], [166.4, 56.6],
                //         [168.9, 62.3], [163.8, 58.5], [167.6, 54.5], [160.0, 50.2], [161.3, 60.3],
                //         [167.6, 58.3], [165.1, 56.2], [160.0, 50.2], [170.0, 72.9], [157.5, 59.8],
                //         [167.6, 61.0], [160.7, 69.1], [163.2, 55.9], [152.4, 46.5], [157.5, 54.3]]
            
                // }, {
                //     name: 'Male',
                //     color: 'rgba(119, 152, 191, .5)',
                //     data: [[174.0, 65.6], [175.3, 71.8], [193.5, 80.7], [186.5, 72.6], [187.2, 78.8],
                //         [181.5, 74.8], [184.0, 86.4], [184.5, 78.4], [175.0, 62.0], [184.0, 81.6],
                //         [180.0, 76.6], [177.8, 83.6], [192.0, 90.0], [176.0, 74.6], [174.0, 71.0],
                //         [184.0, 79.6], [192.7, 93.8], [171.5, 70.0], [173.0, 72.4], [176.0, 85.9],
                //         [176.0, 78.8], [180.5, 77.8], [172.7, 66.2], [176.0, 86.4], [173.5, 81.8],
                //         [178.0, 89.6], [180.3, 82.8], [180.3, 76.4], [164.5, 63.2], [173.0, 60.9],
                //         [183.5, 74.8], [175.5, 70.0], [188.0, 72.4], [189.2, 84.1], [172.8, 69.1],
                //         [170.0, 59.5], [182.0, 67.2], [170.0, 61.3], [177.8, 68.6], [184.2, 80.1],
                //         [186.7, 87.8], [171.4, 84.7], [172.7, 73.4], [175.3, 72.1], [180.3, 82.6]]
                // }]
            });
        }
    };

    return service;
}

export default {
    name: 'ChartGeneratorService',
    fn: ChartGeneratorService
};
